var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mb-5",attrs:{"justify":"center"}},[_c('v-col',{staticClass:"pr-md-15",attrs:{"cols":"12","md":"6"}},[_c('monitors')],1),_c('v-col',{staticClass:"pl-md-15",attrs:{"cols":"12","md":"6"}},[_c('cash-desk')],1),_c('v-col',{staticClass:"pr-md-15",attrs:{"cols":"12","md":"6"}},[_c('sampling-station')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }